import { useContext, useState as classicUseState } from 'react';
import { GlobalMenu } from '@components';
import { useState } from '@hookstate/core';
import { ITagCategory } from '@models/TagCategory.model';
import { NavigationContext } from '@layout/navigation/navigation';
import { InviteUserRole } from '@models/Invite.model';
import { Container, Divider } from './CategoriesMenu.styles';
import { DeleteDialog } from './Components/DeleteDialog/DeleteDialog';
import { EditCategorieDialog } from './Components/EditCategorieDialog/EditCategorieDialog';

interface ICategoriesMenu {
  tagCategory: ITagCategory;
}

const CategoriesMenu = ({ tagCategory }: ICategoriesMenu) => {
  const openDeleteDialog = useState(false);
  const [openEditCategorieDialog, setOpenEditCategorieDialog] =
    classicUseState<boolean>(false);

  const { role } = useContext(NavigationContext);

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Options"
        paddingTop="6px"
        itemList={[
          {
            disabled:
              ![InviteUserRole.ADMIN].includes(role) ||
              tagCategory.name === 'Uncategorized',
            disableToolTip: [InviteUserRole.ADMIN].includes(role),
            toolTipText:
              tagCategory.name === 'Uncategorized'
                ? 'This category cannot be edited'
                : 'Only Admins can edit a category',
            toolTipId: 'editCategoryTooltip',
            label: 'Edit',
            iconName: 'edit',
            onClick: () => {
              setOpenEditCategorieDialog(true);
            },
          },
          {
            disabled:
              ![InviteUserRole.ADMIN].includes(role) ||
              tagCategory.name === 'Uncategorized',
            disableToolTip: [InviteUserRole.ADMIN].includes(role),
            toolTipText:
              tagCategory.name === 'Uncategorized'
                ? 'This category cannot be deleted'
                : 'Only Admins can delete a category',
            toolTipId: 'deleteCategoryTooltip',
            label: 'Delete',
            iconName: 'trash',
            onClick: () => {
              openDeleteDialog.set(true);
            },
          },
        ]}
      />

      <Divider height="6px" />

      {openDeleteDialog.value && (
        <DeleteDialog open={openDeleteDialog} tagCategory={tagCategory} />
      )}

      {openEditCategorieDialog && (
        <EditCategorieDialog
          tagCategory={tagCategory}
          open={openEditCategorieDialog}
          onClose={() => {
            setOpenEditCategorieDialog(false);
          }}
        />
      )}
    </Container>
  );
};

export { CategoriesMenu };
